"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tabs = void 0;
var _react = require("react");
var _Button = require("../Button");
var _Icon = require("../Icon");
var _Tabs = require("./Tabs.styles");
var _Menu = require("../../UI/Menu");
var _hooks = require("../../hooks");
var _Tabs2 = require("./Tabs.labels");
var _jsxRuntime = require("react/jsx-runtime");
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Tabs = function Tabs(props) {
  var _tabs$;
  var id = props.id,
    defaultTabId = props.defaultTabId,
    tabs = props.tabs,
    category = props.category,
    onTabClick = props.onTabClick;
  var _useDeviceData = (0, _hooks.useDeviceData)(),
    isMobile = _useDeviceData.isMobile;
  var _useListChildren = (0, _hooks.useListChildren)(tabs, isMobile),
    outerDivRef = _useListChildren.outerDivRef,
    extraRef = _useListChildren.extraRef,
    contentRef = _useListChildren.contentRef,
    visibleChildren = _useListChildren.visibleChildren,
    setVisibleChildren = _useListChildren.setVisibleChildren,
    hiddenChildren = _useListChildren.hiddenChildren,
    setHiddenChildren = _useListChildren.setHiddenChildren;
  var getLabel = (0, _hooks.useLabels)({
    labels: _Tabs2.labels
  });
  var styles = (0, _Tabs.useStyles)();
  var _useState = (0, _react.useState)(defaultTabId ? defaultTabId : (tabs === null || tabs === void 0 ? void 0 : tabs.length) > 0 ? (_tabs$ = tabs[0]) === null || _tabs$ === void 0 ? void 0 : _tabs$.id : ''),
    _useState2 = _slicedToArray(_useState, 2),
    selectedTabId = _useState2[0],
    setSelectedTabId = _useState2[1];
  var _useState3 = (0, _react.useState)(''),
    _useState4 = _slicedToArray(_useState3, 2),
    sliderClass = _useState4[0],
    setSliderClass = _useState4[1];
  var isSelectedTabVisible = (0, _react.useMemo)(function () {
    return (visibleChildren === null || visibleChildren === void 0 ? void 0 : visibleChildren.findIndex(function (tab) {
      return selectedTabId && tab.id === selectedTabId;
    })) > -1;
  }, [selectedTabId, visibleChildren]);
  var handleTabClick = function handleTabClick(tab) {
    var visibleTabIndex = visibleChildren.findIndex(function (visibleTab) {
      return visibleTab.id === tab.id;
    });
    var hiddenTabIndex = hiddenChildren.findIndex(function (hiddenTab) {
      return hiddenTab.id === tab.id;
    });
    if (visibleTabIndex < 0 && hiddenTabIndex > -1) {
      var lastTab = visibleChildren[visibleChildren.length - 1];
      setVisibleChildren([tab].concat(_toConsumableArray(visibleChildren.slice(0, visibleChildren.length - 1))));
      setHiddenChildren([lastTab].concat(_toConsumableArray(hiddenChildren.slice(0, hiddenTabIndex)), _toConsumableArray(hiddenChildren.slice(hiddenTabIndex + 1))));
    }
    setSelectedTabId(tab.id);
    if (onTabClick) {
      onTabClick(tab);
    }
  };
  (0, _react.useEffect)(function () {
    var style = styles['cc-Tabs__slider'](selectedTabId, visibleChildren);
    setSliderClass(style);
  }, [visibleChildren, selectedTabId, styles]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    id: id,
    "data-testid": id ? "tabs-".concat(id) : 'tabs',
    className: styles['cc-Tabs'],
    ref: outerDivRef,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("ul", {
      ref: contentRef,
      className: styles['cc-Tabs__list'],
      role: "tablist",
      children: visibleChildren === null || visibleChildren === void 0 ? void 0 : visibleChildren.map(function (tab) {
        var isActive = selectedTabId === tab.id;
        return /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
          role: "tab",
          "aria-selected": isActive,
          id: "tab_".concat(tab.id),
          "data-testid": "tab_".concat(tab.id),
          className: styles['cc-Tabs__tab'],
          "data-is-visible": "true",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
            view: "text",
            color: isActive ? 'primary' : 'basic',
            category: category,
            label: tab.id,
            onClick: function onClick(event) {
              event.preventDefault();
              event.stopPropagation();
              handleTabClick(tab);
            },
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
              className: styles['cc-Tabs__tab__label'],
              children: [tab.icon && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
                name: tab.icon,
                width: 16,
                height: 16
              }), tab.label]
            })
          })
        }, tab.id);
      })
    }), isSelectedTabVisible && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: sliderClass
    }), hiddenChildren.length > 0 ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      id: "tab_hidden",
      className: styles['cc-Tabs__tab'],
      ref: extraRef,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Menu.Menu, {
        btnProps: {
          view: 'text',
          role: 'tab',
          color: 'basic',
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
            className: styles['cc-Tabs__tab__label'],
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              className: styles['cc-Tabs__tab__dots'],
              children: "..."
            }), getLabel('more')]
          })
        },
        options: hiddenChildren.map(function (tab) {
          return {
            value: tab.id,
            label: tab.label,
            isSelected: tab.id === selectedTabId,
            onClick: function onClick() {
              handleTabClick(tab);
            }
          };
        })
      })
    }) : null]
  });
};
exports.Tabs = Tabs;